export default __webpack_public_path__ + "locales/profile.ky.json";